import { computed, observable } from 'mobx';
import _ from 'lodash';
import type { ApprovalAuthorityResponseArgs } from '../approval_authority/approval_authority';
import ApprovalAuthority, {
  convertApprovalAuthorityResponseToArgs
} from '../approval_authority/approval_authority';
import type { UserResponseArgs } from '../user/user2';
import User, { convertUserResponseToArgs } from '../user/user2';
import OrganizationAddress, {
  convertOrganizationAddressResponseToArgs
} from './organization_address/organization_address2';
import type { OrganizationAddressResponseArgs } from './organization_address/organization_address2';

export type DepartmentResponseArgs = {
  id: number;
  code: string;
  name: string;
  approval_authorities?: ApprovalAuthorityResponseArgs[];
  approvers?: UserResponseArgs[];
  // TODO: reserve_confirm移行で使われてなければ消す
  // address?: string;
  // postal_code?: string;
  // addressee?: string;
  organization_address?: OrganizationAddressResponseArgs;
};

export type DepartmentArgs = {
  id: number;
  code: string;
  name: string;
  approvalAuthorities?: ApprovalAuthority[];
  approvers?: User[];
  // TODO: reserve_confirm移行で使われてなければ消す
  // address?: string;
  // postalCode?: string;
  // addressee?: string;
  organizationAddress?: OrganizationAddress;
};

export const convertDepartmentResponseToArgs = (response: DepartmentResponseArgs): DepartmentArgs => {
  return {
    id: response.id,
    code: response.code,
    name: response.name,
    approvalAuthorities: response.approval_authorities?.map(
      approvalAuthority => new ApprovalAuthority(convertApprovalAuthorityResponseToArgs(approvalAuthority))
    ),
    approvers: response.approvers?.map(user => new User(convertUserResponseToArgs(user))),
    // TODO: reserve_confirm移行で使われてなければ消す
    // address: response.address,
    // postalCode: response.postal_code,
    // addressee: response.addressee,
    organizationAddress: response.organization_address
      ? new OrganizationAddress(convertOrganizationAddressResponseToArgs(response.organization_address))
      : undefined
  };
};

export default class Department {
  @observable id: number;
  @observable code: string;
  @observable name: string;
  @observable approvalAuthorities?: ApprovalAuthority[];
  @observable approvers: User[];
  // TODO: reserve_confirm移行で使われてなければ消す
  // @observable address: string;
  // @observable postalCode: string;
  // @observable addressee: string;
  @observable organizationAddress?: OrganizationAddress;

  constructor(args: DepartmentArgs) {
    this.id = args.id;
    this.code = args.code;
    this.name = args.name;
    this.approvalAuthorities = args.approvalAuthorities;
    this.approvers = args.approvers || [];
    // TODO: reserve_confirm移行で使われてなければ消す
    // this.address = args.address || '';
    // this.postalCode = args.postalCode || '';
    // this.addressee = args.addressee || '';
    this.organizationAddress = args.organizationAddress;
  }

  @computed get noAddress(): boolean {
    return _.isEmpty(this.organizationAddress?.location);
  }

  @computed get description(): string {
    if (this.noAddress) {
      return `${this.name}:住所が登録されていません`;
    }
    const postalCode = this.organizationAddress?.postalCode;
    const address = this.organizationAddress?.location;
    const addressee = this.organizationAddress?.addressee;
    return `${this.name}:${postalCode} ${address} ${addressee}`;
  }

  @computed get descriptionWithCode(): string {
    return `${this.code}:${this.name}`;
  }
}
